// extracted by mini-css-extract-plugin
export default {"header":"onlines_header__igcqH","list":"onlines_list__GAf6G","list_item":"onlines_list_item__PedyZ","list_avatar":"onlines_list_avatar__qZtaC","coin_img":"onlines_coin_img__MEtXk"};